import { render, staticRenderFns } from "./SpeakersSection.vue?vue&type=template&id=54a8d9ca&scoped=true"
import script from "./SpeakersSection.vue?vue&type=script&lang=js"
export * from "./SpeakersSection.vue?vue&type=script&lang=js"
import style0 from "./SpeakersSection.vue?vue&type=style&index=0&id=54a8d9ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a8d9ca",
  null
  
)

export default component.exports